import { makeStyles } from 'tss-react/mui';

const name = 'ProjectActions';

export const useProjectActionsStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),

    whiteSpace: 'nowrap',

    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',

      width: '100%',
      marginTop: theme.spacing(4),
    },
  },
  skeleton: {
    display: 'inline-block',
  },
  codeExampleButton: {
    padding: 0,
    height: 30,
    minHeight: 30,
    marginLeft: theme.spacing(2),
    whiteSpace: 'nowrap',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),

    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      marginLeft: 0,
    },
  },
  addNetworkButton: {
    '&&': {
      boxShadow: `0 0 0 2px ${theme.palette.background.default}`,
      border: 'none',
    },
  },
}));
